export default __webpack_public_path__ + "static/media/lightswitch_double_10.bf079b9f.svg";